import React, { type ReactElement, type ReactNode } from 'react';

import classNames from 'classnames';

interface Props {
  children: ReactNode;
  className?: string;
}

export function ResponsiveWrapper({
  children,
  className,
}: Props): ReactElement {
  return (
    <div className={classNames('mx-auto w-full md:w-[1168px]', className)}>
      {children}
    </div>
  );
}
